import { useQuery } from '@tanstack/react-query'
import { useApiClient } from '../useApiClient'
import { getRatioDimApplicability } from '../endpoints/ratioDimApplicability'

export function useRatioDimApplicability(ratioKpi: string | null) {
  const client = useApiClient()
  return useQuery({
    queryKey: ['v_ratio_dim_applicability', ratioKpi] as const,
    queryFn: () => getRatioDimApplicability(client, ratioKpi!),
    enabled: ratioKpi !== null,
  })
}
